import { loading, handleErrorException, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const saveDefaultLaborHours = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.DEFAULT_LABOR_HOURS_SAVE_LOADING, true));
      await MPWWebApi.postGenericInsertUpdate(
        'SiteMaster/WriteDefaultLaborHoursSites',
        model
      );
      dispatch(success(types.DEFAULT_LABOR_HOURS_SAVE_SUCCESSFUL, true));
    } catch (exception) {
      const defaultErrorMessage = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving the data. Please try again',
      };
      dispatch(
        handleErrorException(
          exception,
          types.DEFAULT_LABOR_HOURS_SAVE_DEFAULT_LABOR_HOURS_ERROR,
          defaultErrorMessage
        )
      );
    } finally {
      dispatch(loading(types.DEFAULT_LABOR_HOURS_SAVE_LOADING, false));
    }
  };
};

export const getDefaultLaborHourSites = (fiscalYear) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.DEFAULT_LABOR_HOURS_FETCH_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        `SiteMaster/GetDefaultLaborHourSites/${fiscalYear}`
      );
      dispatch(
        success(
          types.DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS,
          response.data.Data
        )
      );
    } catch (exception) {
      const defaultErrorMessage = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching the data. Please try again',
      };
      dispatch(
        handleErrorException(
          exception,
          types.DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS_ERROR,
          defaultErrorMessage
        )
      );
    } finally {
      dispatch(loading(types.DEFAULT_LABOR_HOURS_FETCH_LOADING, false));
    }
  };
};

export const setSaveSuccessful = (successful) => {
  return {
    type: types.DEFAULT_LABOR_HOURS_SAVE_SUCCESSFUL,
    payload: successful,
  };
};

export const clearErrors = () => {
  return {
    type: types.DEFAULT_LABOR_HOURS_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/state/actions.js